var map = {
	"./azw-ic.svg": "bed9",
	"./azw3-ic.svg": "2127",
	"./epub-ic.svg": "4d72",
	"./mobi-ic.svg": "2b42",
	"./mp4-ic.svg": "36bb",
	"./pdf-ic.svg": "efa0",
	"./png-ic.svg": "d1b2",
	"./txt-ic.svg": "708e",
	"./viwoods-ic.svg": "2f10",
	"./zip-ic.svg": "8a86"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "db37";